<template>
  <div class="ml-6 permission-row item-border-bottom">
    <div class="mb-3">
      <ngc-checkbox
        :selected.prop="permission.value"
        :title-text="permission.display_name"
        :disabled="viewOnly || permission.view_only"
        @change="handleChange(permission)"
      />
    </div>
    <template v-if="permission.value && permission.children.length > 0">
      <div
        v-for="(child, index) in permission.children"
        :key="index"
        class="ml-12 mb-3"
      >
        <ngc-checkbox
          :selected.prop="child.value"
          :title-text="child.display_name"
          :disabled="viewOnly"
          @change="handleChange(child)"
        />
      </div>
    </template>
  </div>
</template>

<script>

export default {
  name: 'PermissionRow',
  props: {
    permission: {
      type: Object,
      required: true
    },
    nonDefaultPermissions: {
      type: Array,
      required: false,
      default: () => []
    },
    viewOnly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    handleChange (permission) {
      const changedPermissions = []
      permission.value = !permission.value
      changedPermissions.push(permission.key)
      if (permission.children.length > 0) {
        permission.children.forEach(child => {
          if (child.value !== permission.value) {
            child.value = permission.value
            changedPermissions.push(child.key)
          }
        })
      }
      this.$emit('permissionChange', changedPermissions)
    }
  }
}
</script>

<style lang="scss" scoped>

.permission-row {
  margin: 0;
}

// Fade view-only / unavailable permissions the way the SNUI checkbox did — it
// dimmed the whole control (label + box). Gator's default disabled label text
// is too dark on its own.
ngc-checkbox[disabled] {
  opacity: 0.45;
}

</style>
